function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".ls-1{fill:#ed6f46;}.ls-2{fill:#343f4e;}.ls-3{fill:#f2efdc;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("polyline", {
  className: "ls-1",
  points: "81.8 142.87 51.49 144.15 46.8 131.34 37.41 122.38 24.18 120.67 14.36 125.37 4.12 136.89 2.48 142.58 2.41 74.58 63.45 73.3 71.13 98.05 93.75 98.48 95.03 66.47 114.66 66.9 144.11 80.55 146.25 130.49"
}), React.createElement("path", {
  className: "ls-2",
  d: "M277.14,137.6H152.53a1.68,1.68,0,0,1-1.68-1.68V23.46a1.68,1.68,0,1,1,3.36,0V134.23H277.14a1.69,1.69,0,0,1,0,3.37Z"
}), React.createElement("rect", {
  className: "ls-2",
  x: 146.33,
  y: 117.72,
  width: 5.51,
  height: 3.66
}), React.createElement("path", {
  className: "ls-2",
  d: "M0,143.31V73.83a2.25,2.25,0,0,1,2.25-2.25H63.66a2.24,2.24,0,0,1,2.12,1.51l7,22.6h19.6v-29a2.25,2.25,0,0,1,2.25-2.25h19.46a2.3,2.3,0,0,1,.9.19l31.6,13.84a2.25,2.25,0,0,1,1.35,2.06v62.76a2.25,2.25,0,0,1-2.25,2.25H2.25A2.25,2.25,0,0,1,0,143.31ZM143.42,82,113.6,69H96.86v29a2.25,2.25,0,0,1-2.25,2.25H71.16A2.25,2.25,0,0,1,69,98.68l-7-22.61H4.49v65H143.42Z"
}), React.createElement("circle", {
  className: "ls-3",
  cx: 27.44,
  cy: 142.58,
  r: 22.72,
  transform: "translate(-107.11 88.01) rotate(-57.03)"
}), React.createElement("path", {
  className: "ls-2",
  d: "M2.48,142.58a25,25,0,1,1,25,25A25,25,0,0,1,2.48,142.58Zm4.49,0a20.48,20.48,0,1,0,20.47-20.47A20.5,20.5,0,0,0,7,142.58Z"
}), React.createElement("path", {
  className: "ls-2",
  d: "M17.21,142.58a10.24,10.24,0,1,1,10.23,10.24A10.24,10.24,0,0,1,17.21,142.58Zm4.49,0a5.75,5.75,0,1,0,5.74-5.74A5.76,5.76,0,0,0,21.7,142.58Z"
}), React.createElement("path", {
  className: "ls-2",
  d: "M91.82,88.43V77.63a2.24,2.24,0,0,1,2.25-2.24h26.51a6.75,6.75,0,0,1,6.74,6.74v1.8a6.75,6.75,0,0,1-6.74,6.74H94.07A2.24,2.24,0,0,1,91.82,88.43Zm4.49-8.55v6.3h24.27a2.24,2.24,0,0,0,2.24-2.25v-1.8a2.24,2.24,0,0,0-2.24-2.25Z"
}), React.createElement("path", {
  className: "ls-3",
  d: "M103.25,103V134.4a10.38,10.38,0,0,0,20.76,0V102.56a32.13,32.13,0,1,1-20.76.39Z"
}), React.createElement("path", {
  className: "ls-2",
  d: "M79.82,133.17a34.48,34.48,0,0,1,22.67-32.33,2.25,2.25,0,0,1,3,2.11V134.4a8.13,8.13,0,1,0,16.26,0V102.56a2.26,2.26,0,0,1,2.94-2.14,34.39,34.39,0,1,1-44.88,32.75Zm46.44,1.23a12.63,12.63,0,1,1-25.25,0V106.34a29.89,29.89,0,1,0,25.25-.53Z"
}), React.createElement("path", {
  className: "ls-3",
  d: "M113.63,144.78a10.41,10.41,0,0,1-10.38-10.38V103a32.2,32.2,0,0,1,20.76-.39V134.4A10.41,10.41,0,0,1,113.63,144.78Z"
}), React.createElement("path", {
  className: "ls-2",
  d: "M101,134.4V103a2.24,2.24,0,0,1,1.48-2.11,34.61,34.61,0,0,1,22.21-.42,2.25,2.25,0,0,1,1.56,2.14V134.4a12.63,12.63,0,1,1-25.25,0Zm4.49-29.83V134.4a8.13,8.13,0,1,0,16.26,0V104.25A30,30,0,0,0,105.5,104.57Z"
}), React.createElement("path", {
  className: "ls-2",
  d: "M108.34,133.93a5.29,5.29,0,1,1,5.29,5.29A5.29,5.29,0,0,1,108.34,133.93Zm4.49,0a.8.8,0,1,0,.8-.8A.8.8,0,0,0,112.83,133.93Z"
}), React.createElement("path", {
  className: "ls-2",
  d: "M2.25,85.28H42.58a2.25,2.25,0,0,0,0-4.5H2.25a2.25,2.25,0,0,0,0,4.5Z"
}), React.createElement("path", {
  className: "ls-2",
  d: "M90.63,97.76a2.25,2.25,0,0,0,2.25-2.25V58.84a2.28,2.28,0,0,0-.66-1.59L84.4,49.43c-.88-.88-1.31.11-2.19,1s-2.8.37-1.93,1.25l8.11,8.1V95.51A2.24,2.24,0,0,0,90.63,97.76Z"
}), React.createElement("path", {
  className: "ls-2",
  d: "M76.44,57.88A2.25,2.25,0,0,0,78,57.22L89.52,45.73a2.25,2.25,0,1,0-3.18-3.18L74.85,54a2.25,2.25,0,0,0,1.59,3.84Z"
}), React.createElement("path", {
  className: "ls-2",
  d: "M129.9,75.44,109.59,8.15c-.82-2.54-2.85-4.27-5-4.27H26.91c-3,0-5.43,3.09-5.43,6.89V72.71H17.6V10.77C17.6,4.83,21.78,0,26.91,0h77.65c3.87,0,7.38,2.81,8.73,7l20.32,67.33Z"
}), React.createElement("path", {
  className: "ls-1",
  d: "M42.87,70.79h0l.12,0Z"
}), React.createElement("path", {
  className: "ls-1",
  d: "M43,70.8h0v.12S43,70.85,43,70.8Z"
}), React.createElement("path", {
  className: "ls-1",
  d: "M43.44,71.22h0v.12S43.45,71.26,43.44,71.22Z"
}), React.createElement("path", {
  className: "ls-1",
  d: "M43.69,71.61h0l.11,0Z"
}), React.createElement("path", {
  className: "ls-1",
  d: "M44.52,72.44h0l.11,0Z"
}), React.createElement("path", {
  className: "ls-1",
  d: "M81.16,70.4l0,.12,0-.13Z"
}), React.createElement("path", {
  className: "ls-1",
  d: "M81,70.18v.08l0-.08h0Z"
}), React.createElement("path", {
  className: "ls-1",
  d: "M80.34,69.57v.12l0-.12Z"
}), React.createElement("path", {
  className: "ls-2",
  d: "M92.11,95.24H91c0-.35-.06-.64-.12-.92-.3-1.41-.67-1.61-1.73-1.84s-2.37-.57-3.55-.88a5.17,5.17,0,0,1-2.77-1.76c-.2-.24-.41-.46-.62-.69l0,.1v-.1c-.12-.18-.23-.38-.35-.56a5,5,0,0,1-1-2.43,23.86,23.86,0,0,0-.45-2.64s0-.06.07-.07c.93-.35.93-.35.93-1.33V76.45a2.1,2.1,0,0,1,.1-.77c.07.1.14.2.2.3-.21-5.35,2.65-10.41,1.24-15.79a1.23,1.23,0,0,0-.25-.57c-.58-.64-3.14-.4-3.94-.43l-5-.25a5.87,5.87,0,0,1-1.38-.18,5.64,5.64,0,0,0-.7-.21,3.14,3.14,0,0,0-.75,0A82.24,82.24,0,0,1,61,58.7c-.87,0-1.74-.13-2.61-.18a.68.68,0,0,1-.7-.63c-.09-.69-.12-1.39-.18-2.19,5.32,0,10.64.18,16,0,2-.06,3.77-1.07,5.74-1.52a9.71,9.71,0,0,1,2.09-1.67,15.56,15.56,0,0,1-1.16-2.72c-.1-.32-8.45-1.24-9.44-1.48a80.43,80.43,0,0,1-9.43-3.07A10.11,10.11,0,0,1,59,43.77c-1.26-1-2.48-2-3.72-2.93,0,0-.14,0-.21,0l-.14,0,.14-.06c-.35-.43-.71-.86-1-1.31-1.06-1.44-2.07-2.9-3.16-4.31a15.67,15.67,0,0,0-1.67-1.79c-1.17-1.15-1.25-2-.31-3.33.66.07,1.3.17,1.95.2a1.15,1.15,0,0,0,1.38-1c.24-.84.43-1.69.61-2.54a.9.9,0,0,1,.7-.73c.7-.2.91-.56.7-1.29s-.45-1.26-.57-1.92a3,3,0,0,1,.15-1.16c.22-.79.46-1.57.71-2.34a3.64,3.64,0,0,1,.31-.7,10.17,10.17,0,0,0,.75-1.32A1,1,0,0,0,55,16a19.07,19.07,0,0,0-4.4-2c-.64-.2-1.31-.35-2-.52H46.41a2.14,2.14,0,0,1-.34.09,4.29,4.29,0,0,0-3,1.36,10.26,10.26,0,0,0-2.59,3.54,9.23,9.23,0,0,0,.21,7.11,2.51,2.51,0,0,1,.12,2.29.8.8,0,0,0,0,.15,5.06,5.06,0,0,1-1.72,3,12.46,12.46,0,0,0-4,7.35A44,44,0,0,0,34.66,46a1.27,1.27,0,0,1-.27.84,8.44,8.44,0,0,0-2.18,6q-.16,6-.15,12.1c0,3,.14,5.92.22,8.87a20.14,20.14,0,0,1,3.56-.32,19.28,19.28,0,0,1,5.82.86,17.26,17.26,0,0,1,9.41-2.6c6.22,0,10.75,2.61,13.61,6.4l.28.08V77.06l.72,0c2.6-.19,3.69-1.29,3.8-3.9a22.25,22.25,0,0,0,0-2.31.51.51,0,0,1,.32-.56c.44-.19.87-.4,1.39-.64.34,2.41.67,4.75,1,7.08s.68,4.68,1,7.07l1.06.06a11.36,11.36,0,0,1-.75,6.46c-.06-.16-.12-.32-.17-.49,0,.1-.11.18-.16.3a8.93,8.93,0,0,1-.87,4.26q.14.38.24.78c.06.42.12.84.17,1.26,1.54.13,3.09.23,4.63.27a45.44,45.44,0,0,0,6.38-.39,45.62,45.62,0,0,1,6.81-.41c.55,0,1.11.08,1.66.14C92.18,95.75,92.14,95.5,92.11,95.24Z"
}), React.createElement("rect", {
  className: "ls-1",
  x: 161.8,
  y: 26.01,
  width: 38.55,
  height: 28.29
}), React.createElement("path", {
  className: "ls-2",
  d: "M200.35,55.73H161.8a1.44,1.44,0,0,1-1.44-1.44V26a1.44,1.44,0,0,1,1.44-1.44h38.55A1.43,1.43,0,0,1,201.78,26V54.29A1.43,1.43,0,0,1,200.35,55.73Zm-37.12-2.87h35.68V27.44H163.23Z"
}), React.createElement("rect", {
  className: "ls-1",
  x: 199.99,
  y: 26.01,
  width: 38.55,
  height: 28.29
}), React.createElement("path", {
  className: "ls-2",
  d: "M238.54,55.73H200a1.44,1.44,0,0,1-1.44-1.44V26A1.44,1.44,0,0,1,200,24.57h38.55A1.43,1.43,0,0,1,240,26V54.29A1.43,1.43,0,0,1,238.54,55.73Zm-37.12-2.87H237.1V27.44H201.42Z"
}), React.createElement("rect", {
  className: "ls-1",
  x: 237.92,
  y: 26.01,
  width: 38.55,
  height: 28.29
}), React.createElement("path", {
  className: "ls-2",
  d: "M276.46,55.73H237.92a1.43,1.43,0,0,1-1.44-1.44V26a1.43,1.43,0,0,1,1.44-1.44h38.54A1.43,1.43,0,0,1,277.9,26V54.29A1.43,1.43,0,0,1,276.46,55.73Zm-37.11-2.87H275V27.44H239.35Z"
}), React.createElement("rect", {
  className: "ls-1",
  x: 161.8,
  y: 54.29,
  width: 38.55,
  height: 28.29
}), React.createElement("path", {
  className: "ls-2",
  d: "M200.35,84H161.8a1.45,1.45,0,0,1-1.44-1.44V54.29a1.44,1.44,0,0,1,1.44-1.43h38.55a1.43,1.43,0,0,1,1.43,1.43V82.58A1.44,1.44,0,0,1,200.35,84Zm-37.12-2.87h35.68V55.73H163.23Z"
}), React.createElement("rect", {
  className: "ls-1",
  x: 199.99,
  y: 54.29,
  width: 38.55,
  height: 28.29
}), React.createElement("path", {
  className: "ls-2",
  d: "M238.54,84H200a1.45,1.45,0,0,1-1.44-1.44V54.29A1.44,1.44,0,0,1,200,52.86h38.55A1.43,1.43,0,0,1,240,54.29V82.58A1.44,1.44,0,0,1,238.54,84Zm-37.12-2.87H237.1V55.73H201.42Z"
}), React.createElement("rect", {
  className: "ls-1",
  x: 237.92,
  y: 54.29,
  width: 38.55,
  height: 28.29
}), React.createElement("path", {
  className: "ls-2",
  d: "M276.46,84H237.92a1.44,1.44,0,0,1-1.44-1.44V54.29a1.43,1.43,0,0,1,1.44-1.43h38.54a1.43,1.43,0,0,1,1.44,1.43V82.58A1.44,1.44,0,0,1,276.46,84Zm-37.11-2.87H275V55.73H239.35Z"
}), React.createElement("rect", {
  className: "ls-1",
  x: 161.8,
  y: 82.3,
  width: 38.55,
  height: 28.29
}), React.createElement("path", {
  className: "ls-2",
  d: "M200.35,112H161.8a1.45,1.45,0,0,1-1.44-1.44V82.3a1.44,1.44,0,0,1,1.44-1.43h38.55a1.43,1.43,0,0,1,1.43,1.43v28.29A1.44,1.44,0,0,1,200.35,112Zm-37.12-2.87h35.68V83.74H163.23Z"
}), React.createElement("rect", {
  className: "ls-1",
  x: 199.99,
  y: 82.3,
  width: 38.55,
  height: 28.29
}), React.createElement("path", {
  className: "ls-2",
  d: "M238.54,112H200a1.45,1.45,0,0,1-1.44-1.44V82.3A1.44,1.44,0,0,1,200,80.87h38.55A1.43,1.43,0,0,1,240,82.3v28.29A1.44,1.44,0,0,1,238.54,112Zm-37.12-2.87H237.1V83.74H201.42Z"
}), React.createElement("rect", {
  className: "ls-1",
  x: 237.92,
  y: 82.3,
  width: 38.55,
  height: 28.29
}), React.createElement("path", {
  className: "ls-2",
  d: "M276.46,112H237.92a1.44,1.44,0,0,1-1.44-1.44V82.3a1.43,1.43,0,0,1,1.44-1.43h38.54a1.43,1.43,0,0,1,1.44,1.43v28.29A1.44,1.44,0,0,1,276.46,112Zm-37.11-2.87H275V83.74H239.35Z"
}), React.createElement("rect", {
  className: "ls-3",
  x: 161.92,
  y: 118.57,
  width: 14.6,
  height: 8.87
}), React.createElement("path", {
  className: "ls-2",
  d: "M176.52,128.88h-14.6a1.43,1.43,0,0,1-1.43-1.44v-8.87a1.44,1.44,0,0,1,1.43-1.44h14.6a1.44,1.44,0,0,1,1.44,1.44v8.87A1.43,1.43,0,0,1,176.52,128.88ZM163.36,126h11.73v-6H163.36Z"
}), React.createElement("rect", {
  className: "ls-3",
  x: 261.51,
  y: 118.57,
  width: 14.6,
  height: 8.87
}), React.createElement("path", {
  className: "ls-2",
  d: "M276.11,128.88h-14.6a1.43,1.43,0,0,1-1.43-1.44v-8.87a1.44,1.44,0,0,1,1.43-1.44h14.6a1.44,1.44,0,0,1,1.44,1.44v8.87A1.43,1.43,0,0,1,276.11,128.88ZM263,126h11.73v-6H263Z"
}), React.createElement("rect", {
  className: "ls-3",
  x: 212.55,
  y: 118.57,
  width: 14.6,
  height: 8.87
}), React.createElement("path", {
  className: "ls-2",
  d: "M227.15,128.88h-14.6a1.44,1.44,0,0,1-1.44-1.44v-8.87a1.45,1.45,0,0,1,1.44-1.44h14.6a1.44,1.44,0,0,1,1.43,1.44v8.87A1.43,1.43,0,0,1,227.15,128.88ZM214,126h11.74v-6H214Z"
}), React.createElement("rect", {
  className: "ls-3",
  x: 161.8,
  y: 110.62,
  width: 114.81,
  height: 8.04
}), React.createElement("path", {
  className: "ls-2",
  d: "M276.61,120.1H161.8a1.45,1.45,0,0,1-1.44-1.44v-8a1.44,1.44,0,0,1,1.44-1.43H276.61a1.44,1.44,0,0,1,1.44,1.43v8A1.45,1.45,0,0,1,276.61,120.1Zm-113.38-2.87h112v-5.18h-112Z"
})));

var SvgLoadingShipment = function SvgLoadingShipment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 278.82 167.55",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLoadingShipment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LoadingShipment.8c79195f.svg";
export { ForwardRef as ReactComponent };